import React from "react";

import { CustomEventType } from "@intelligems/ig-types";
import { customEventIconMap } from "@src/features/customEvents/helpers";
import { WebTraffic } from "@src/images/Icons/CustomEvents/WebTraffic";

export const RenderCustomEventIcon = ({
  eventType,
}: {
  eventType: CustomEventType;
}) => {
  const IconComponent = customEventIconMap[eventType];
  return IconComponent ? (
    <IconComponent sx={{ fontSize: "35px" }} />
  ) : (
    <WebTraffic sx={{ fontSize: "35px" }} />
  );
};
